import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class TabService {
  tabIndex = 0;

  constructor() {
  }

}
